import React, {Component} from 'react'

var Loader                  = require('react-loader');
var PostingStoreJson        = require('../../build/contracts/PostingStore.json');
var PostingStoreAddr        = PostingStoreJson.networks["4"].address;

class SubmitPosting extends Component {
  constructor(props) {
    super(props);

    this.state = {
      credential: {},
      savingCredential: false
    };
    this.props.web3.eth.getTransactionReceiptMined     = require('./transactionReceipt')
  }

  componentWillMount() {

  }

  addPostings(){


    this.setState({savingCredential: true});
    let credential = this.state.credential;
    let post = credential.post.trim();
    let This = this;
    let Props = this.props;
    let SetState = this;
    let sender = this.props.web3.eth.accounts[0];
    console.log(sender)
    this.props.postingStoreContractInstance.amountOfTokensForPosting({gas: 500000,gasPrice: 1200000000}).then((tokens)=>{
      let tokenRequired   = tokens/1000000000000000000;
      this.props.echoLinkContractInstance.allowance(sender,PostingStoreAddr,{gas: 500000,gasPrice: 1200000000}).then((result)=>{
          let availableTokens   = result/1000000000000000000;
          if(availableTokens >= tokenRequired){
            Props.postingStoreContractInstance.addPostings(post,{gas: 500000,gasPrice: 1200000000}).then((result1)=>{
              Props.web3.eth.getTransactionReceiptMined(result1.tx,10,function(txHash){
                if(txHash.txStatus === 0){
                  This.setState({savingCredential: false});
                  Props.addNotification(`Transaction Exection Failed!`,"error");
                }
                if(txHash.txStatus === 1){
                  console.log("posting added successfully");
                  SetState.setState({savingCredential: false});
                  Props.addNotification(`Data saved successfully !`,"success");
                  SetState.setState({credential: {}});
                  Props.onSubmit(result1.tx);
                }
              })
            })
          }
          else if(availableTokens === 0){
            Props.echoLinkContractInstance.approve(PostingStoreAddr,tokens,{gas: 500000,gasPrice: 1200000000}).then((result)=>{
              Props.web3.eth.getTransactionReceiptMined(result.tx,10,function(txHash){
                if(txHash.txStatus === 0){
                  This.setState({savingCredential: false});
                  Props.addNotification(`Transaction Exection Failed!`,"error");
                }
                if(txHash.txStatus === 1){
                  console.log("approved successfully");
                  Props.postingStoreContractInstance.addPostings(post,{gas: 500000,gasPrice: 1200000000}).then((result1)=>{
                     Props.web3.eth.getTransactionReceiptMined(result1.tx,10,function(txHash){
                      if(txHash.txStatus === 0){
                        This.setState({savingCredential: false});
                        Props.addNotification(`Transaction Exection Failed!`,"error");
                      }
                      if(txHash.txStatus === 1){
                        console.log("posting added successfully");
                        SetState.setState({savingCredential: false});
                        // let details = log.args._details;
                        Props.addNotification(`Data saved successfully !`,"success");
                        SetState.setState({credential: {}});
                        Props.onSubmit(result1.tx);
                      }
                    })
                  })
                }
              })
            })
          }
          else{
            Props.echoLinkContractInstance.approve(PostingStoreAddr,0,{gas: 500000,gasPrice: 1200000000}).then((result)=>{
              Props.web3.eth.getTransactionReceiptMined(result.tx,10,function(txHash){
                if(txHash.txStatus === 0){
                  This.setState({savingCredential: false});
                  Props.addNotification(`Transaction Exection Failed!`,"error");
                }
                if(txHash.txStatus === 1){
                  console.log("first Approve success");
                  Props.echoLinkContractInstance.approve(PostingStoreAddr,tokens,{gas: 500000,gasPrice: 1200000000}).then((results)=>{
                    Props.web3.eth.getTransactionReceiptMined(results.tx,10,function(txHash){
                      if(txHash.txStatus === 0){
                        This.setState({savingCredential: false});
                        Props.addNotification(`Transaction Exection Failed!`,"error");
                      }
                      if(txHash.txStatus === 1){
                        console.log("approved successfully");
                        Props.postingStoreContractInstance.addPostings(post,{gas: 500000,gasPrice: 1200000000}).then((result1)=>{
                          Props.web3.eth.getTransactionReceiptMined(result1.tx,10,function(txHash){
                            if(txHash.txStatus === 0){
                              This.setState({savingCredential: false});
                              Props.addNotification(`Transaction Exection Failed!`,"error");
                            }
                            if(txHash.txStatus === 1){
                              console.log("posting added successfully");
                              SetState.setState({savingCredential: false});
                        
                              // let details = log.args._details;
                              Props.addNotification(`Data saved successfully !`,"success");
                              SetState.setState({credential: {}});
                              Props.onSubmit(result1.tx);
                            }
                          })
                        })
                      }
                    })
                  })
                }
              })
            })

          }
      })
    })
    

  }

  updateInputValue(e, field) {
    let credential = this.state.credential;
    credential[field] = e.target.value;
    this.setState({credential});
  }


  validForm() {
    if (!this.props.postingStoreContractInstance && !this.props.echoLinkContractInstance) {
      return false;
    }

    let credential = this.state.credential;
    return credential.post && credential.post.trim()
  }

  render() {
    return (
      <div className="SubmitPosting">

        <h4>Submit a Job Post:</h4>

        <form className="pure-form" onSubmit={(e) => event.preventDefault()}>
          <fieldset className="pure-group">
            <input type="text" className="pure-input-1-2" placeholder="Post: java,Reactjs,Nodejs,etc."
                   value={this.state.credential.post} onChange={e => this.updateInputValue(e, 'post')}/>
          </fieldset>


          <Loader loaded={!this.state.savingCredential}>
            <button type="button" className="pure-button pure-input-1-2 button-success"
                    disabled={!this.validForm() || this.state.savingCredential}
                    onClick={() => this.addPostings()}>Post
            </button>
          </Loader>
        </form>
      </div>
    );
  }
}

export default SubmitPosting;



// WEBPACK FOOTER //
// ./src/components/SubmitPosting.js